import React from "react";

import Background from "../../../assets/clothes/clothes-select.png";
import ImageA from "../../../assets/clothes/clothes-option-a.png";
import ImageB from "../../../assets/clothes/clothes-option-b.png";

import GameSelectionLayout from "../GameSelectionLayout";

const ClothesPage2 = ({ setCurrentPage, setGarbageQtty }) => {
  const handleClickA = () => {
    setGarbageQtty((prev) => prev + 5);
    setCurrentPage("clothes-3");
  };

  const handleClickB = () => {
    setGarbageQtty((prev) => prev + 10);
    setCurrentPage("clothes-4");
  };

  return (
    <GameSelectionLayout
      bg={Background}
      imageA={ImageA}
      textA="중고거래"
      onClickA={handleClickA}
      imageB={ImageB}
      textB="헌옷수거함"
      onClickB={handleClickB}
      currentIndex={6}
    >
      이제 입기 애매한 옷 엄청 많네..
      <br />
      멀쩡한 건 당근에 팔고
      <br />
      나머지는 헌옷수거함에 버릴까?
      <br />
      에이...
      <br />
      시간 조율하기도 귀찮은데 그냥 버려?
    </GameSelectionLayout>
  );
};

export default ClothesPage2;
